function Guyana({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_1318)">
        <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
        <path d="M16.0001 0C13.1712 0 10.5145 0.735125 8.20874 2.02325V29.9767C10.5146 31.2649 13.1712 32 16.0001 32C24.8366 32 32.0001 24.8365 32.0001 16C32.0001 7.1635 24.8366 0 16.0001 0Z" fill="#6DA544"/>
        <path d="M8.25575 1.99695C7.24919 2.55476 6.30931 3.21776 5.45062 3.97151C5.53744 3.89539 5.62512 3.82014 5.7135 3.74589L17.9676 16L5.71344 28.2541C5.625 28.1799 5.53737 28.1046 5.45056 28.0285C6.30925 28.7823 7.24919 29.4452 8.25569 30.0031L32 16L8.25575 1.99695Z" fill="#F0F0F0"/>
        <path d="M6.90441 2.83643C6.41647 3.1743 5.94785 3.53786 5.50128 3.92643L16 16.0001L5.50122 28.0737C5.94778 28.4623 6.41641 28.8259 6.90435 29.1637L29.2612 16.0001L6.90441 2.83643Z" fill="#FFDA44"/>
        <path d="M5.71347 3.74585C5.35778 4.04472 5.01453 4.35804 4.68628 4.68623L14.6087 16L4.68628 27.3137C5.01453 27.642 5.35772 27.9554 5.71347 28.2541L17.9676 16L5.71347 3.74585Z" fill="black"/>
        <path d="M4.68628 4.68628C-1.56209 10.9347 -1.56209 21.0653 4.68628 27.3138C7.26834 24.7317 9.75165 22.2484 16 16L4.68628 4.68628Z" fill="#D80027"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Guyana;
